<template>
    <div>
      <Breadtabsheader/>
        <div class="h-content w-content">
            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="类型" prop="styles">
							    <el-select v-model="q.type" placeholder="请选择">
							        <el-option
							                v-for="item in fljsstyle"
							                :key="item.value"
							                :label="item.label"
							                :value="item.value">
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="时间" class="nianboxs">
							    <el-date-picker
										style="width: 100%;"
							            v-model="q.date"
							            :clearable="true"
							            type="month"
							            value-format="yyyy-MM"
							            placeholder="选择日期">
							    </el-date-picker>
							</el-form-item>
                            <el-form-item label="渠道" prop="channelCode">
                                <brselect category="fl_sales_region_main" :v="q.channelCode" v-model="q.channelCode" :clearable="true"/>
                            </el-form-item>
                            <el-form-item label="链群" prop="rebateChainGroup">
                                <el-select v-model="q.rebateChainGroup" placeholder="请选择">
                                    <el-option
                                            v-for="item in lqList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
						</div>
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="经销商类型" prop="agentNameLike">
                                <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                            </el-form-item>
                            <el-form-item label="区域" prop="area">
                                <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true" :clearable="true"/>
                            </el-form-item>
                            <el-form-item  class="right-btn"></el-form-item>
                            <el-form-item  class="right-btn">
                                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :summary-method="getSummaries"
                          show-summary
                          :border="true"
						  max-height="600"
                >
                    <el-table-column
                            type="index"
                            label="#"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="area"
							width="80"
                            :show-overflow-tooltip="true"
                            label="区域"
                    >
                        <template slot-scope="scope">
                            <dictname category="YLRegion" :v="scope.row.area"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="qianyueCount"
                            :show-overflow-tooltip="true"
                            label="签约客户数量"
							width="120"
                    >
						<template slot-scope="scope">
						    <div style="text-align: right;">{{scope.row.qianyueCount}}</div>
						</template>
                    </el-table-column>
                    <el-table-column label="0履约" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="sla"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.sla}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zba"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zba).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="0＜履约率＜50%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="slb"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.slb}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbb"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbb).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="50%≤履约率＜70%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="slc"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.slc}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbc"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbc).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="70%≤履约率＜100%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="sld"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.sld}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbd"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbd).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="履约率≥100%" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="sle"
                                :show-overflow-tooltip="true"
                                label="数量"
                        >
							<template slot-scope="scope">
							    <div style="text-align: right;">{{scope.row.sle}}</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="zbe"
                                :show-overflow-tooltip="true"
                                label="占比"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{new big(Number(scope.row.zbe).toFixed(0)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        components: {},
        data() {
            return {
                fljsstyle: [
                    {
                        value: 'year',
                        label: '年'
                    },
                    {
                        value: 'month',
                        label: '月'
                    },
					{
						value: 'j1',
						label: '一季度'
					},
					{
						value: 'j2',
						label: '二季度'
					},
					{
						value: 'j3',
						label: '三季度'
					},
					{
						value: 'j4',
						label: '四季度'
					},
                ],
                lqList: [
                    {
                        value: 'ct',
                        label: '传统'
                    },
                    {
                        value: 'ybw',
                        label: '样本网'
                    },
                    {
                        value: 'ypw',
                        label: '药品网'
                    },
                    {
                        value: 'swaq',
                        label: '生物安全'
                    },
                    {
                        value: 'lxj',
                        label: '离心机'
                    },
                    {
                        value: 'pyx',
                        label: '培养箱'
                    },
                    {
                        value: 'ND5',
                        label: '血液网'
                    },
                    {
                        value: 'ND4',
                        label: '疫苗网'
                    },
                ],
                q: {
                    pageSize: 20,
                    pageNo: 1,
                    total: 0,
                    rebateChainGroup:null,
                    date: null,
                    type:null,
                    channelCode:null,
                    areaCode:null,
                    agentType:null,
                },
                //table列表
                tableData: [],
            }
        },
        created() {
			this.q = {
                pageSize: 20,
                pageNo: 1,
                total: 0,
				date: this.doHandleDate(),
				type:'month',//默认月累计
				rebateChainGroup:'ct'
			}
            this.query();
        },
        methods: {
            //日期
			doHandleDate() {
			    var myDate = new Date();
			    var tYear = myDate.getFullYear();
			    var tMonth = myDate.getMonth();
			    var m = tMonth + 1;
			    if (m.toString().length == 1) {
			        m = "0" + m;
			    }
			    return tYear +'-'+ m;
			},
            //重置
            qingkong(){
                this.q = {
                    pageSize: 20,
                    pageNo: 1,
                    total: 0,
                    type:'month',
                    date :this.doHandleDate(),
                    rebateChainGroup:'ct',
                }
                this.query();
            },
            handleFilter() {
                this.query();
            },
            query() {
                ss.fanli.customerLvyueTongjiPage(this.q).then(rd=>{
                    this.q.total = rd.total;
					var rds = rd.records;
					for(var i=0;i<rds.length;i++){
						 rds[i].zba = (rds[i].zba).slice(0,(rds[i].zba).length-1)
						 rds[i].zbb = (rds[i].zbb).slice(0,(rds[i].zbb).length-1)
						 rds[i].zbc = (rds[i].zbc).slice(0,(rds[i].zbc).length-1)
						 rds[i].zbd = (rds[i].zbd).slice(0,(rds[i].zbd).length-1)
						 rds[i].zbe = (rds[i].zbe).slice(0,(rds[i].zbe).length-1)
					}
                    this.tableData = rds;
                });
            },
            getSummaries(param){
				console.log(param)
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
						sums[12] = (sums[11]/ sums[2] * 100).toFixed(0)+"%";
						sums[4] = (sums[3]/ sums[2] * 100).toFixed(0)+"%";
						sums[6] = (sums[5]/ sums[2] * 100).toFixed(0)+"%";
						sums[8] = (sums[7]/ sums[2] * 100).toFixed(0)+"%";
						sums[10] = (sums[9]/ sums[2] * 100).toFixed(0)+"%";
                    } else {
                        sums[1] = '';
                    }
                });
                return sums;
            },

            //开票明细批量导出
            exportExcel() {
                updownfile.down("/api/swyl/fl/viewFlLvyueTongji/downloadExcel", this.q, "post");
            },
        }
    }
</script>
<style>
    .el-table thead.is-group th{
        background-color: #57aefe;
    }
	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
</style>